const transparentSpan = () => {
  let cubes = document.querySelectorAll(".cubes");
  let cubes_div = document.querySelector('.cubes_div');
  let spanArr = [];
  let interval;
  let timer = 0;
  let randomNum;
  cubes.forEach((e) => {
    spanArr.push(e);
  });

  interval = setInterval(() => {
    timer++;
    randomNum = Math.floor(Math.random() * cubes.length);
    spanArr[randomNum].classList.add("whiteSpan");
    if (timer > 1000) {
      console.log("Finish");
      cubes_div.style.display = "none";
      clearInterval(interval);
    }
  }, 0.01);
};

export default transparentSpan;
